import { REVIEW_TYPES } from 'constants/review-types';
import { ROUTE, ROUTE_REGEXP } from 'constants/route';

export const LinkBuilder = {
  getFirmLink: firmAcronym => {
    return ROUTE_REGEXP.FIRM_PROFILE.replace(':firmname', firmAcronym);
  },

  getFirmTabReviewLink: firmAcronym => {
    return ROUTE_REGEXP.FIRM_SECTION_REVIEWS.replace(
      ':firmname',
      firmAcronym.replace(/\s/g, '')
    );
  },

  getReviewLink: (type, firmAcronym, publicName) => {
    if (REVIEW_TYPES.EMPLOYEE === type) {
      return LinkBuilder.getEmployeeLink(firmAcronym, publicName);
    }

    if (REVIEW_TYPES.INTERVIEW === type) {
      return LinkBuilder.getInterviewLink(firmAcronym, publicName);
    }

    if (REVIEW_TYPES.OVERVIEW === type || REVIEW_TYPES.COMPANY === type) {
      return LinkBuilder.getOverviewLink(firmAcronym, publicName);
    }
  },

  getEmployeeLink: (firmAcronym, publicName) => {
    return ROUTE_REGEXP.FIRM_REVIEW.replace(
      ':firmname',
      firmAcronym.replace(/\s/g, '')
    )
      .replace(':type', 'employee')
      .replace(':reviewName', publicName);
  },

  getInterviewLink: (firmAcronym, publicName) => {
    return ROUTE_REGEXP.FIRM_REVIEW.replace(
      ':firmname',
      firmAcronym.replace(/\s/g, '')
    )
      .replace(':type', 'interview')
      .replace(':reviewName', publicName);
  },

  getOverviewLink: (firmAcronym, publicName) => {
    return ROUTE_REGEXP.FIRM_REVIEW.replace(
      ':firmname',
      firmAcronym.replace(/\s/g, '')
    )
      .replace(':type', 'overview')
      .replace(':reviewName', publicName);
  },

  getAddReviewLink: reviewType => {
    if (
      REVIEW_TYPES.COMPANY === reviewType ||
      REVIEW_TYPES.OVERVIEW === reviewType
    ) {
      return ROUTE.ADD_REVIEW_COMPANY;
    }

    if (REVIEW_TYPES.INTERVIEW === reviewType) {
      return ROUTE.ADD_REVIEW_INTERVIEW;
    }

    if (REVIEW_TYPES.EMPLOYEE === reviewType) {
      return ROUTE.ADD_REVIEW_EMPLOYEE;
    }
  },

  getProfileLink: id => {
    return ROUTE_REGEXP.CANDIDATE_PROFILE.replace(':id(\\d+)', id);
  },

  getJobLink: id => {
    return ROUTE_REGEXP.JOB.replace(':id(\\d+)', id);
  },

  getProjectLink: id => {
    return ROUTE_REGEXP.PROJECT.replace(':id(\\d+)', id);
  },

  getShortlistLink: id => {
    return ROUTE_REGEXP.SEARCH_SHORTLIST.replace(':id(\\d+)', id);
  },

  getJobProfileLink: id => {
    return ROUTE_REGEXP.SEARCH_JOB_PROFILE.replace(':id(\\d+)', id);
  },

  getProjectProfileLink: id => {
    return ROUTE_REGEXP.SEARCH_PROJECT_PROFILE.replace(':id(\\d+)', id);
  },

  getSubscriptionJobLink: id => {
    return ROUTE_REGEXP.SEARCH_SUBSCRIPTION_PROFILE.replace(
      ':page(subscription-searches)',
      'subscription-searches'
    ).replace(':id(\\d+)', id);
  },

  getJobCandidatesAppLink: id => {
    return ROUTE_REGEXP.SEARCH_VIEW_APPLICANTS.replace(
      ':type(process|project)',
      'process'
    ).replace(':id(\\d+)', id);
  },

  getProjectCandidatesAppLink: id => {
    return ROUTE_REGEXP.SEARCH_VIEW_APPLICANTS.replace(
      ':type(process|project)',
      'project'
    ).replace(':id(\\d+)', id);
  },

  getProcessPublicLink: (id, type) => {
    return ROUTE_REGEXP.PROCESS_PUBLIC.replace(
      ':type(process|project)',
      type
    ).replace(':id', id);
  },

  getCandidatePictureSizeLink: (url, size) => {
    if (!url || url.match(/^.*\/image\/no-icon/i)) {
      return '/image/no-icon';
    }

    const ext = url.match(/jpeg|jpg|png$/i)[0];
    const path = url
      .replace(/\w*\.(jpeg|jpg|png)+$/i, '')
      .replace(/size\//i, '');

    return `${path}size/${size}.${ext}`;
  },

  getCandidateResumeLink: (id, revision) => {
    return (
      `/download/resume/id/${id}` + (revision ? `?revision=${revision}` : '')
    );
  },

  getFileLink: (id, candidateId) => {
    return `/download/file/id/${id}/candidateId/${candidateId}`;
  },

  getAllFileLink: (id, candidateId) => {
    return `/download/files/typeId/${id}/candidateId/${candidateId}`;
  },

  getInboxAttachedFileLink: (file, messageId, attachId = null) => {
    return attachId
      ? encodeURI(`/download/message-attach/id/${attachId}/${file}`)
      : encodeURI(`/download/message/id/${messageId}/${file}`);
  },

  getPreparatoryFileLink: (id, ext) => {
    return ext === 'pdf'
      ? `/preparatory-pdf/index/id/${id}`
      : `/api/preparatory/xls/id/${id}`;
  },

  getEmailTemplateFollowupLink: id => {
    return ROUTE_REGEXP.SEARCH_EMAILS_TEMPLATES_EDIT.replace(':id(\\d+)', id);
  },
};

export default LinkBuilder;
